module.exports = __webpack_public_path__ + "static/media/icons8-delivery.46f3ebb7.svg";